import React, { useState } from "react";
import SimpleReactValidator from "simple-react-validator";

const ContactForm = (props) => {
  const [forms, setForms] = useState({
    name: "",
    email: "",
    subject: "",
    phone: "",
    company: "",
    message: "",
  });
  const [validator] = useState(
    new SimpleReactValidator({
      className: "errorMessage",
      messages: {
        required: "Este campo é obrigatório.",
        email: "Por favor, insira um e-mail válido.",
        phone: "Por favor, insira um telefone válido.",
        alpha_space: "Por favor, insira apenas letras.",
      },
    })
  );
  const changeHandler = (e) => {
    setForms({ ...forms, [e.target.name]: e.target.value });
    if (validator.allValid()) {
      validator.hideMessages();
    } else {
      validator.showMessages();
    }
  };

  const submitHandler = (e) => {
    e.preventDefault();
    if (validator.allValid()) {
      validator.hideMessages();

      // Estruturar a mensagem para WhatsApp
      const whatsappMessage = `🚀 *NOVO CONTATO - Somar CLOUD*

👤 *Nome:* ${forms.name}
📧 *Email:* ${forms.email}
📱 *Telefone:* ${forms.phone}
💬 *Mensagem:* ${forms.message}

---
_Mensagem enviada através do formulário de contato do site da Somar Cloud_`;

      const encodedMessage = encodeURIComponent(whatsappMessage);
      const whatsappUrl = `https://wa.me/551130901260?text=${encodedMessage}`;

      // Abrir WhatsApp
      window.open(whatsappUrl, "_blank");

      // Limpar formulário após envio
      setForms({
        name: "",
        email: "",
        subject: "",
        phone: "",
        company: "",
        message: "",
      });
    } else {
      validator.showMessages();
    }
  };

  return (
    <form onSubmit={(e) => submitHandler(e)} className="contact-form">
      <div className="row">
        <div className="col-lg-6">
          <div className="input-field">
            <label htmlFor="text1">Nome*</label>
            <div className="input-box">
              <input
                value={forms.name}
                type="text"
                name="name"
                className="form-control"
                onBlur={(e) => changeHandler(e)}
                onChange={(e) => changeHandler(e)}
              />
              {validator.message("name", forms.name, "required|alpha_space")}
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="input-field">
            <label htmlFor="text2">Email*</label>
            <div className="input-box">
              <input
                value={forms.email}
                type="email"
                name="email"
                className="form-control"
                onBlur={(e) => changeHandler(e)}
                onChange={(e) => changeHandler(e)}
              />
              {validator.message("email", forms.email, "required|email")}
            </div>
          </div>
        </div>
        <div className="col-lg-12">
          <div className="input-field">
            <label htmlFor="text3">Telefone*</label>
            <div className="input-box">
              <input
                value={forms.phone}
                type="phone"
                name="phone"
                className="form-control"
                onBlur={(e) => changeHandler(e)}
                onChange={(e) => changeHandler(e)}
              />
              {validator.message("phone", forms.phone, "required|phone")}
            </div>
          </div>
        </div>
        <div className="col-lg-12">
          <div className="input-field text-field">
            <label htmlFor="text5">Mensagem</label>
            <div className="input-box">
              <textarea
                onBlur={(e) => changeHandler(e)}
                onChange={(e) => changeHandler(e)}
                value={forms.message}
                type="text"
                name="message"
                className="form-control"
                placeholder="Como podemos ajudá-lo?"
              ></textarea>
              {validator.message("message", forms.message, "required")}
            </div>
          </div>
        </div>
      </div>
      <div className="cp-det-btn mt-20 d-grid">
        <button className="cp-btn" type="submit">
          Enviar mensagem <i className="fal fa-arrow-right"></i>
        </button>
      </div>
    </form>
  );
};

export default ContactForm;
